module.exports = __webpack_public_path__ + "img/bg1.5e551a98.jpg";